export const formatPercentage = (value: number): string => {
    return `${value}%`;
};

export const formatChannelList = (channels: string, maxVisible: number = 2): [string, string] => {
  const channelArray = channels ? channels.split("$!$").map(channel => channel.trim()) : [];

  return [
    channelArray.slice(0, maxVisible).join(", "),
    channelArray.length > maxVisible ? `외 ${channelArray.length - maxVisible}개` : ""
  ];
};

export const formatDate = (isoString: string) => {
  const date = new Date(isoString);
  const month = String(date.getUTCMonth() + 1).padStart(2, "0"); 
  const day = String(date.getUTCDate()).padStart(2, "0"); 

  const hours = String(date.getUTCHours()).padStart(2, "0"); 
  const minutes = String(date.getUTCMinutes()).padStart(2, "0");

  return `${month}.${day} ${hours}:${minutes}`;
};

export const formatStandardDate = (dateString: string): string => {
  const month = dateString.substring(4, 6);
  const day = dateString.substring(6, 8);

  return `(${month}월 ${day}일 기준)`;
};

export const formatPdfDate = (dateString: string): string => {
  const year = dateString.substring(0, 4);
  const month = dateString.substring(4, 6);
  const day = dateString.substring(6, 8);

  return `${year}.${month}.${day}`;
};